import axios from '../utils/axios';

export const generateAnswers = async (jobBoardJobId, resumeUuid) => {
	const result = await axios.post('/api/auto-apply/answers/generate', {
		job_board_job_id: jobBoardJobId,
		resume_uuid: resumeUuid,
	}, {
		validateStatus: () => true,
	});

	return result;
};

export const getAnswerGeneration = async (generationUuid) => {
	const result = await axios.get(`/api/auto-apply/answers/generations/${generationUuid}`, {
		validateStatus: () => true,
	});

	return result;
};

export const getAnswers = async (params = {}) => {
	const result = await axios.get('/api/auto-apply/answers', { params });

	return result.data;
};

export const updateAnswer = async (answerUuid, data) => {
	const result = await axios.patch(`/api/auto-apply/answers/${answerUuid}`, data, {
		validateStatus: () => true,
	});

	return result;
};

export const rewriteAnswer = async (answerUuid, instruction) => {
	const result = await axios.post(`/api/auto-apply/answers/${answerUuid}/rewrite`, {
		instruction,
	}, {
		validateStatus: () => true,
	});

	return result;
};

export const generateSingleAnswer = async (answerUuid) => {
	const result = await axios.post(`/api/auto-apply/answers/${answerUuid}/generate`, {}, {
		validateStatus: () => true,
	});

	return result;
};

export const approveAnswers = async (answerIds, saveToMemoryIds = []) => {
	const result = await axios.post('/api/auto-apply/answers/approve', {
		answer_ids: answerIds,
		save_to_memory_ids: saveToMemoryIds,
	}, {
		validateStatus: () => true,
	});

	return result;
};
